module.exports = __webpack_public_path__ + "ls.jpg?9687e00901244a20eeeaec745e807f61";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ls.jpg
// module id = 23
// module chunks = 0